import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Dealer } from 'src/app/models/entities/dealer';
import { VLogoCustomer } from 'src/app/models/entities/v-logo-customer';
import { DealerService } from 'src/app/services/dealer.service';
import { LogoService } from 'src/app/services/logo.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';

@Component({
  selector: 'app-dealer-update',
  templateUrl: './dealer-update.component.html',
  styleUrls: ['./dealer-update.component.css']
})
export class DealerUpdateComponent implements OnInit {

 
  destroy$ = new Subject<void>();
  customers$: Observable<VLogoCustomer[]>;
  form: FormGroup;
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private dealerService: DealerService,
    private userService: NbsUserService,
    private logoService: LogoService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.customers$ = this.logoService.getCustomers().pipe(map(result => result.data));
    this.getDealerById();
  }

  getDealerById() {
    const dealerId = parseInt(this.activatedRoute.snapshot.paramMap.get('dealerId'));
    this.dealerService.getById(dealerId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.form.patchValue(data.data);
    })
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      dealerName: ["", Validators.required],
      customerId: ["", Validators.required],
      isActive: true
    })
  }

  update() {
    if (this.form.valid) {
      const dealer: Dealer = this.form.getRawValue();
      dealer.userId = this.userService.getUserId();
      this.dealerService.update(dealer).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.toastrService.success(data.message, "Başarılı");
          this.router.navigateByUrl('/dealer');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }


}
